module.exports = __webpack_public_path__ + "static/quartz-d2c65e667bcffe8da2f671ff223c5bbb.svg";